module.exports = __webpack_public_path__ + "img/vodka.bd39dfa4.png";